<template>
  <div class="pagina ativa">
    <div class="pagina-titulo">Em construcao</div>
    <p style="color:#888;">Esta tela ainda esta sendo portada do sistema original. Volte em breve.</p>
  </div>
</template>

<script>
export default { name: 'EmBreve' }
</script>
